import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSlideToggleChange, MatSlideToggle } from '@angular/material/slide-toggle';
import { BaseDataTableFilter } from '../../../../../shared/components/data-table/filters/components/data-table-filter/BaseDataTableFilter';
import { DataTableFilterMessageService } from '../../../../../shared/components/data-table/filters/components/data-table-filter-message-service';
import { ReservationFilterStateService } from '../../../services/reservation-filter-state.service';
import { ReservationMessageService } from '../../../services/reservation-message.service';
import { addFilterStatusToFilterStatusText } from '../../../../../utilities/TableFilterUtility';

@Component({
  selector: 'app-reservation-status-filter',
  templateUrl: './reservation-status-filter.component.html',
  styleUrls: ['./reservation-status-filter.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatSlideToggle
  ]
})
export class ReservationStatusFilterComponent extends BaseDataTableFilter implements OnInit {

  constructor(
    private filterStateService: ReservationFilterStateService, 
    private reservationMessageService: ReservationMessageService, 
    private filterMessageService: DataTableFilterMessageService
  ) {
    super(filterMessageService);
  }

  ngOnInit(): void {
    if (this.filterStateService.isStatusFilterActive()) {
      this.filterMessageService.setActive({ filterId: this.id, active: true, value: this.getFilterStatusText() });
    }
  }

  onUpcomingToggle(event: MatSlideToggleChange): void {
    this.filterStateService.upcoming = event.checked;
  }

  onInHomeToggle(event: MatSlideToggleChange): void {
    this.filterStateService.isHome = event.checked;
  }

  onCompletedToggle(event: MatSlideToggleChange): void {
    this.filterStateService.completed = event.checked;
  }

  onCanceledToggle(event: MatSlideToggleChange): void {
    this.filterStateService.canceled = event.checked;
  }

  onClaimFiledToggle(event: MatSlideToggleChange): void {
    this.filterStateService.claimFiled = event.checked;
  }

  onApplyClicked(): void {
    if (this.filterStateService.allStatusFiltersDisabled() || this.filterStateService.allStatusFiltersEnabled()) {
      this.filterMessageService.setActive({ filterId: this.id, active: false });
    } else {
      this.filterMessageService.setActive({ filterId: this.id, active: this.filterStateService.isStatusFilterActive(), value: this.getFilterStatusText() });
    }
    this.reservationMessageService.applyFilter();
  }

  onClearClicked(): void {
    this.filterStateService.resetStatusFilters();
    this.reservationMessageService.applyFilter();
    this.filterMessageService.setActive({ filterId: this.id, active: false });
  }

  getStateService(): ReservationFilterStateService {
    return this.filterStateService;
  }

  private getFilterStatusText(): any {
    let filterValue: string[] = [];
    addFilterStatusToFilterStatusText("UPCOMING", this.filterStateService.isUpcomingFilterActive(), filterValue);
    addFilterStatusToFilterStatusText("IN HOME", this.filterStateService.isInHomeFilterActive(), filterValue);
    addFilterStatusToFilterStatusText("COMPLETED", this.filterStateService.isCompletedFilterActive(), filterValue);
    addFilterStatusToFilterStatusText("CANCELED", this.filterStateService.isCanceledFilterActive(), filterValue);
    addFilterStatusToFilterStatusText("CLAIM FILED", this.filterStateService.isClaimFiledFilterActive(), filterValue);
    return filterValue;
  }
}